'use strict';

import "babel-polyfill";

$('.navToggle').click(function() {
    $('.nav').toggleClass('show');
    $('.navToggle').toggleClass('open');
});

$(".learn").click(function(event) {
    event.preventDefault();
    $('html, body').animate({
        scrollTop: window.innerHeight
    }, 600);
});

$('.exiter').click(function(e) {
    e.preventDefault();
    var href = $(this).attr('href');
    $('.nav').toggleClass('fadeOut');
    setTimeout(function() {$('body').toggleClass('fadeOut');}, 200);
    setTimeout(function() {window.location = href;}, 700);
});

$('.get-started').click(function() {
    Intercom('showNewMessage', "Hi Gust, I'm interested in learning more about Gust Equity Management.");
});

var whitenav = $('.nav.alternate');
var mobilelogo = $('.mobile-logo');
var navToggle = $('.navToggle');

$('body').addClass('visited-one-page');
whitenav.removeClass('hideme');
mobilelogo.removeClass('hideme');

$(window).on('scroll', () => {
    let timer;
    if (timer > Date.now()) {
        return;
    }
    if (window.pageYOffset > 60) {
        whitenav.addClass('flip');
        mobilelogo.addClass('flip');
        navToggle.addClass('flip');
    } else {
        whitenav.removeClass('flip');
        mobilelogo.removeClass('flip');
        navToggle.removeClass('flip');
    }
    timer = Date.now() + 100;
});

var QueryString = function () {
    // This function is anonymous, is executed immediately and
    // the return value is assigned to QueryString!
    var query_string = {};
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
        var pair = vars[i].split("=");
        // If first entry with this name
        if (typeof query_string[pair[0]] === "undefined") {
            query_string[pair[0]] = pair[1];
            // If second entry with this name
        } else if (typeof query_string[pair[0]] === "string") {
            var arr = [ query_string[pair[0]], pair[1] ];
            query_string[pair[0]] = arr;
            // If third or later entry with this name
        } else {
            query_string[pair[0]].push(pair[1]);
        }
    }
    return query_string;
} ();
window.onload = function() {
    var c = QueryString.c || sessionStorage.getItem('c');
    if (c) {
        sessionStorage.setItem('c', c);
    }

    var nocard = sessionStorage.getItem('nocard');
    if (nocard) {
        sessionStorage.setItem('nocard', true);
    }
};



// WEBPACK FOOTER //
// ./_src/external/external.js